/* eslint-disable import/prefer-default-export */
// TraceCode前缀算法：取'spot'字符在ASCII中的字符编码，取前5位
export var TraceCode = {
  /** 重试请求失败 */
  RETRY_REQUEST_ERROR: 11511501,
  /** 重试请求失败达最大次数限制 */
  RETRY_REQUEST_MAX_ERROR: 11511502,
  /** 使用本地缓存 */
  USE_CACHE_CODE_DATA: 11511503,
  /** 本地缓存获取失败，使用硬编码交易对 */
  USE_HARD_CODE_DATA: 11511504,
  /** 代码运行报错，进入catch */
  CODE_EXECUTION_ERROR: 11511505,
  /** all/v3 接口请求异常 */
  API_SPLIT_REQUEST_ERROR: 11511506,
  /** 合并交易对数据异常 */
  MERGE_SYMBOLS_ERROR: 11511507,
  /** CDN接口请求异常（http状态码200，但是接口返回的code不是0） */
  CDN_REQUEST_CODE_ERROR: 11511508,
  /** v3接口请求异常（http状态码200，但是接口返回的code不是0） */
  V3_REQUEST_CODE_ERROR: 11511509,
  /** 降级请求v2版本 */
  FALLBACK_TO_V2: 11511510,
  /** 降级v2版本请求异常 */
  FALLBACK_TO_V2_REQUEST_ERROR: 11511511
};